import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const FinanceHubInvoiceSummaryBucketFieldsFragmentDoc = gql`
  fragment FinanceHubInvoiceSummaryBucketFields on UnpaidInvoiceSummaryBucket {
    amount_in_micros
    count
  }
`;
export const FinanceHubInvoiceSummaryDocument = gql`
  query FinanceHubInvoiceSummary {
    getUnpaidInvoiceSummary {
      currency_code
      current {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      days_0_14 {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      days_15_30 {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      days_31_60 {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      days_61_90 {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      days_90_plus {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      overdue {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      total_credits {
        ...FinanceHubInvoiceSummaryBucketFields
      }
      total_due {
        ...FinanceHubInvoiceSummaryBucketFields
      }
    }
  }
  ${FinanceHubInvoiceSummaryBucketFieldsFragmentDoc}
`;
export function useFinanceHubInvoiceSummaryQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >(FinanceHubInvoiceSummaryDocument, options);
}
export function useFinanceHubInvoiceSummaryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >(FinanceHubInvoiceSummaryDocument, options);
}
export type FinanceHubInvoiceSummaryQueryHookResult = ReturnType<
  typeof useFinanceHubInvoiceSummaryQuery
>;
export type FinanceHubInvoiceSummaryLazyQueryHookResult = ReturnType<
  typeof useFinanceHubInvoiceSummaryLazyQuery
>;
export type FinanceHubInvoiceSummaryQueryResult = Apollo.QueryResult<
  Types.FinanceHubInvoiceSummaryQuery,
  Types.FinanceHubInvoiceSummaryQueryVariables
>;

/**
 * Wrapped version of useGeneratedFinanceHubInvoiceSummaryQuery using Pepper's useWrappedQuery
 */
export function useGeneratedFinanceHubInvoiceSummaryQuery(
  options?: Apollo.QueryHookOptions<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >(FinanceHubInvoiceSummaryDocument, options);
}

/**
 * Wrapped version of useGeneratedFinanceHubInvoiceSummaryLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedFinanceHubInvoiceSummaryLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.FinanceHubInvoiceSummaryQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.FinanceHubInvoiceSummaryQuery,
    Types.FinanceHubInvoiceSummaryQueryVariables
  >(FinanceHubInvoiceSummaryDocument, lazyOptions);
}
